/**
 * AiSecurityNotificationsProducer - headless mount for the bell's server feed
 *
 * Exists as a component purely so the poll hook has a mount point inside
 * `MessagingProvider` that is independent of any route — the bell is in the
 * header, so the feed must survive navigation.
 */

import { useAiSecurityNotifications } from '../../hooks/useAiSecurityNotifications'

// @purpose Headless (renders null) mount that polls AI-security notifications and reconciles them into the MessagingContext bell — mount once inside MessagingProvider, wrapped in an ErrorBoundary.
export const AiSecurityNotificationsProducer = (): null => {
  useAiSecurityNotifications()
  return null
}

export default AiSecurityNotificationsProducer
